(()=>{
  if(window.jeOptionReadinessInitialize){window.jeOptionReadinessInitialize(document);return;}
  const visible=element=>{
    if(!element||element.disabled||element.hidden||element.closest('[hidden],[inert],[aria-hidden="true"]'))return false;
    const style=getComputedStyle(element);
    return style.display!=='none'&&style.visibility!=='hidden'&&element.getClientRects().length>0;
  };
  const initialize=root=>{
    const selector='form[data-je-app-size-expected="true"]';
    const forms=[...(root.matches?.(selector)?[root]:[]),...root.querySelectorAll(selector)];
    forms.forEach(form=>{
      if(form.dataset.jeOptionGuardInitialized)return;
      form.dataset.jeOptionGuardInitialized='true';
      const actions=form.querySelector('[data-je-option-actions]');
      const status=form.querySelector('[data-je-option-status]');
      if(!actions||!status)return;
      let ready=false,frame=0;
      const usable=()=>{
        const stack=form.querySelector('#po_stack19326');
        const select=stack?.querySelector('#po_dropdown19326');
        if(!select||select.options.length<2)return false;
        if(visible(select))return true;
        const appControl=stack.querySelector('#bss-po_dropdown19326');
        return appControl?.getAttribute('tabindex')==='0'&&visible(appControl);
      };
      const sync=()=>{
        frame=0;
        const next=usable();
        if(next===ready)return;
        ready=next;
        actions.toggleAttribute('inert',!ready);
        if(ready)actions.removeAttribute('aria-busy');else actions.setAttribute('aria-busy','true');
        status.hidden=ready;
      };
      const schedule=()=>{if(!frame)frame=requestAnimationFrame(sync);};
      const preventPrematurePurchase=event=>{
        if(usable())return;
        if(event.type==='click'&&!event.target.closest('[data-je-option-actions]'))return;
        event.preventDefault();event.stopImmediatePropagation();status.hidden=false;status.focus();schedule();
      };
      form.addEventListener('click',preventPrematurePurchase,true);
      form.addEventListener('submit',preventPrematurePurchase,true);
      new MutationObserver(schedule).observe(form,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','hidden','disabled','aria-hidden','tabindex']});
      window.addEventListener('resize',schedule,{passive:true});
      setTimeout(()=>{
        if(ready)return;
        status.querySelector('[data-je-option-loading]').hidden=true;
        status.querySelector('[data-je-option-retry]').hidden=false;
      },10000);
      schedule();
    });
  };
  window.jeOptionReadinessInitialize=initialize;
  const start=()=>{
    initialize(document);
    new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)initialize(node);}))).observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
